import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA, BUTTON_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const SPEAKERS_ITEM_OPTION = () => ({
  codigo: 123,
  show: false,
  nome: '',
  cargo: '',
  empresa: '',
  linkedin: '',
  instagram: '',
  twitter: '',
  sobre: '',
  url_avatar: ''
})

export const SPEAKERS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'speakers',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Palestrantes'),
    subtitle: SUBTITLE_SCHEMA('Descrição aqui'),
    buttons: [BUTTON_SCHEMA()],
    bg: BG_SCHEMA(),
    items: [SPEAKERS_ITEM_OPTION()],
    'max-speakers': '10',
    'speakers-by-row': 4,
    typeShow: 'Todos',
    layout: {
      size: '', // possivelmente não utiliza mais
      shadow: '', // possivelmente não utiliza mais
      distance: '', // possivelmente não utiliza mais
      companyPosition: false,
      linkedinIcon: false,
      color1: '',
      color2: '',
      'text-color1': '',
      'text-color2': '',
      'tooltip-color': '#202020',
      'tooltip-text-color': '#FFFFFF',
      type: 'layout1',
      zoom: 125
    }
  }
}

export const beforeParseSpeakers = target => {
  commonBeforeParseMethod(target)
}

export const SPEAKERS_SECTION = config => ({
  schema: SPEAKERS_SCHEMA(config),
  beforeParse: beforeParseSpeakers
})
